var _metadata, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignalVehRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8",
    width: 140.60208,
    height: 307.75797,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs20"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000"
    },
    id: "rect915",
    width: 140.60208,
    height: 307.75797,
    x: 0,
    y: 0,
    ry: 44.816395
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(1085.0886,-455.89025)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ff0000"
    },
    id: "path836",
    cx: -1014.77,
    cy: 516.62024,
    r: 44.595608
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#666666"
    },
    id: "path836-3",
    cx: -1014.4299,
    cy: 611.11041,
    r: 44.595608
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#666666"
    },
    id: "path836-3-6",
    cx: -1014.4299,
    cy: 705.60052,
    r: 44.595608
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalVehRed);
export default __webpack_public_path__ + "static/media/signal_veh_red.bd3d9a4bb87fb6c753e70e522873f87e.svg";
export { ForwardRef as ReactComponent };